import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeUpperComponent } from './badge-upper.component';

@NgModule({
  imports: [CommonModule],
  declarations: [BadgeUpperComponent],
  exports: [BadgeUpperComponent],
})
export class BadgeUpperModule {}
